import { render, staticRenderFns } from "./SigninView.vue?vue&type=template&id=5b80b8be&"
import script from "./SigninView.vue?vue&type=script&lang=js&"
export * from "./SigninView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b80b8be')) {
      api.createRecord('5b80b8be', component.options)
    } else {
      api.reload('5b80b8be', component.options)
    }
    module.hot.accept("./SigninView.vue?vue&type=template&id=5b80b8be&", function () {
      api.rerender('5b80b8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SigninView.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/SigninView.vue
// module id = 503
// module chunks = 7